<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="mat-card-info" (click)="deviceTypesToggle=!deviceTypesToggle">
        <a href="javascript:">Device Types ({{ getFilteredDeviceTypes().length }})</a>
      </mat-card-title>
    </mat-card-header>
    <div class="row" *ngIf="deviceTypesToggle">
      <ng-container *ngIf="getFilteredDeviceTypes() as filteredDevices">
        <table class="table" fxFlex="100" *ngIf="filteredDevices.length > 0">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Platform</th>
              <th>OS Version</th>
              <th>Model</th>
              <th>App Version</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of filteredDevices; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ key.platform }}</td>
              <td>{{ key.platform_version }}</td>
              <td>{{ key.app_device }}</td>
              <td>{{ key.app_version }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>

    </div>
  </mat-card>
</div>